const formatSourceField = (value) =>
  value === 'rents' ? 'Aluguéis' : 'Produtos'

export { formatSourceField }
